import React from "react";
import { evaluateSubscriptionString } from "../../../util/subscription/subscriptions";
import style from "../code.module.css";
import { assemblePriceString, RedeemState } from "./util";
var CodeRedeemStart = function CodeRedeemStart(_ref) {
    var checkResponse = _ref.checkResponse, setRedeemState = _ref.setRedeemState;
    var article = checkResponse.assignedArticles[0];
    return /*#__PURE__*/ React.createElement("div", {
        className: "content-text text-center"
    }, "Sie erhalten mit Ihrem Code:", /*#__PURE__*/ React.createElement("div", {
        className: "font-medium text-2xl mt-2"
    }, evaluateSubscriptionString(article.type, article.duration)), /*#__PURE__*/ React.createElement("div", {
        className: "my-2"
    }, "f\xFCr"), /*#__PURE__*/ React.createElement("div", {
        className: "font-medium text-2xl text-makroOrange"
    }, assemblePriceString(checkResponse)), /*#__PURE__*/ React.createElement("small", {
        className: "block my-3"
    }, "Danach verl\xE4ngert sich das Abonnement zum normalen Preis."), /*#__PURE__*/ React.createElement("div", {
        className: "mt-4"
    }, /*#__PURE__*/ React.createElement("button", {
        onClick: function onClick() {
            return setRedeemState(RedeemState.SUBSCRIBE);
        },
        className: style.buttonOrange
    }, "Code jetzt einl\xF6sen")));
};
export default CodeRedeemStart;
